var exports = {
  "O": "ViewsBackLink__hpsByl",
};

module.exports = exports;
